var map = {
  "./bg.png": "960",
  "./choose_icon.png": "5920",
  "./choosed_bg.png": "324",
  "./choosed_bg_2.png": "1695",
  "./download_icon.png": "4253",
  "./empty.png": "9210",
  "./skill1.png": "7293",
  "./skill1_use.png": "9137",
  "./skill2.png": "1145",
  "./skill2_use.png": "9490",
  "./skill3.png": "8623",
  "./skill3_use.png": "699",
  "./skill4.png": "2752",
  "./skill4_use.png": "6788",
  "./skill5.png": "8505",
  "./skill5_use.png": "7013",
  "./skill_bottom.png": "6722",
  "./tip.png": "1830",
  "./tip_arrow.png": "2832",
  "./tip_top.png": "4714",
  "./title.png": "4019"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 9311;
